export default {"src":"/_next/static/image/public/images/ic_female.381e4d5da9b6c7b146750c4fe5049c5e.svg","height":24,"width":25};